import { BaseEntity } from "yt-ng-framework";

export class VrstaStavkiKodKupcaView extends BaseEntity{
        constructor(){
            super();
        }

        VrstaStavki: string = null;
        Komitent: string = null;
        SifraKodKomitenta: string = null;

        Deserialize(input: any){
            this.ID = input.ID;
            this.VrstaStavki = input.VrstaStavki;
            this.Komitent = input.Komitent;
            this.SifraKodKomitenta = input.SifraKodKomitenta;
            return this;
        }

        Serialize(input: VrstaStavkiKodKupcaView){
            return input;
        }
}